// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    agentId: z.string().min(1).max(21),
    controllerId: z.string().min(1).max(21),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    agentId: z.string().min(1).max(21),
    controllerId: z.string().min(1).max(21),
    createdAt: z.number(),
});
export const AgentControllerRelations = Object.freeze({
    table: 'agent_controller_relations',
    tableSingular: 'agent_controller_relation',
    fields: {
        tenantId: 'tenant_id',
        agentId: 'agent_id',
        controllerId: 'controller_id',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'agentId',
        'controllerId',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
